import { createFileRoute } from "@tanstack/react-router";
import { getCatalogService } from "@/components/site/services-catalog";
import { seo } from "@/lib/seo";
import { serviceJsonLd } from "@/lib/structured-data";

export const Route = createFileRoute("/services/$slug")({
  head: ({ params }) => {
    const service = getCatalogService(params.slug);
    const base = seo({
      title: service?.title ?? "Services",
      description: service?.description ?? "",
      path: service ? `/services/${service.slug}` : "/services",
    });
    if (!service) return base;
    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(serviceJsonLd(service)),
        },
      ],
    };
  },
});
